import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../../hooks/hooks';
import PageLoader from '../../../../../../components/PageLoader';
import ChapterComponent from '../components/chapter.component';
import { selectLMSChaptersQueryItems } from '../../../../../../redux/lms/collections/chapters/selector';
import { lmsChapters } from '../../../../../../redux/lms/collections/chapters/action';
import { lmsModules } from '../../../../../../redux/lms/modules/action';
import { selectLMSModulesListItems } from '../../../../../../redux/lms/modules/selector';

const ManagementLMSChapter = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const parmas: any = useParams();
  const lmsChaptersQuery = useSelector(selectLMSChaptersQueryItems);
  const modulesListItems = useSelector(selectLMSModulesListItems)
  const [isQuery, setIsQuery] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [mediaFiles,setMediaFiles] = useState<any>([])
  const [selectLMSChapters, setSelectLMSChapters] = useState<any>({

  });

  const fetchLMSChaptersQueryById = () => {
    dispatch(lmsChapters.query({
      url: `https://skill.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/lms/chapters/fetch-detail`,
      entity: 'lmsChapters',
      jsonData: {
        Context: {},
        Records: [
          {
            Id: parmas?.id
          }
        ]
      }
    })).then(() => {
      setIsQuery(true);
    });
  }

  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectLMSChapters({ ...selectLMSChapters, [field]: event });
  }
   // media handle form change
  const handleFormMediaItemChange: any = ({ value }: any) => {
    setMediaFiles(value);
  }

  useEffect(() => {
    dispatch(lmsModules.list({
      url: `https://skill.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/lms/modules/fetch`,
      entity: 'lmsCollections',
      jsonData: {}
    })).then(() => {
      if (parmas?.id > 0) {
        fetchLMSChaptersQueryById()
        setIsLoading(false)
      } else {
        setIsLoading(false)
      }
    })
  }, []
  )

  useEffect(() => {
    if (parmas?.id > 0) {
      fetchLMSChaptersQueryById();
      setIsLoading(false);
    } else {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    if (isQuery) {
      setSelectLMSChapters(lmsChaptersQuery?.result?.items);
    }
  }, [isQuery]);

  const handleFormSubmit = async (event: any) => {
    event.preventDefault();
    mediaFiles.splice(
      mediaFiles.length - 1,
      1
    )
    const data = {
      "Id": parmas.id || 0,
      "Title": selectLMSChapters?.Title || '',
      "Description": selectLMSChapters?.Description,
      "ShortDescription": selectLMSChapters?.ShortDescription,
      "ModuleId": selectLMSChapters?.ModuleId || '',
      "DisplayOrder": Number(selectLMSChapters?.DisplayOrder) || '',
      "MediaMappings": {
        "MediaFiles": mediaFiles,
        "Templates": []
      }
    };
    if (parmas?.id > 0) {
      await dispatch(lmsChapters.resetAction({ actionType: 'update' }))
      await dispatch(lmsChapters.update({
        url: `https://skill.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/lms/chapters`,
        entity: 'lmsChapters',
        jsonData: {
          Context: {},
          Records: [data],
        }
      })).then(() => {
        back();
      });
    } else {
      await dispatch(lmsChapters.resetAction({ actionType: 'create' }))
      await dispatch(lmsChapters.create({
        url: `https://skill.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/lms/chapters`,
        entity: 'lmsChapters',
        jsonData: {
          Context: {},
          Records: [data],
        }
      })).then(() => {
        back();
      });
    }
  }

  const back = () => {
    navigate('/management/e-applications/lms/chapters');
  }

  return (
    <>
      {lmsChaptersQuery?.isLoading ? <PageLoader /> :
        <ChapterComponent
          handleInnerFormChange={handleInnerFormChange}
          selectLMSChapters={selectLMSChapters}
         Modulelist= {modulesListItems?.result?.items}
          back={back}
          handleFormSubmit={handleFormSubmit}
          onFormItemChange={handleFormMediaItemChange}
          id={parmas?.id}
        />
      }
    </>
  );
}

export default ManagementLMSChapter;
